import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { LastLocationProvider } from 'react-router-last-location';

import store, { loadInitialData } from '../state';
import routes from './routes';

class AppRouter extends Component {
  componentWillMount() {
    if (!this.props.isInitialized) {
      store.dispatch(loadInitialData());
    }
  }

  render() {
    if (this.props.isInitialized) {
      return (
        <BrowserRouter>
          <LastLocationProvider>
            {renderRoutes(routes)}
          </LastLocationProvider>
        </BrowserRouter>
      );
    }
    return null;
  }
}

AppRouter.propTypes = {
  isInitialized: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isInitialized: state.get('isInitialized'),
});

export default connect(mapStateToProps)(AppRouter);



// WEBPACK FOOTER //
// ./src/router/app-router.jsx